export const ADD_RESOLVE = 'SET_RESOLVE';
export const CLEAR_RESOLVE = 'CLEAR_RESOLVE';
